import {
  Box,
  Center,
  Container,
  Heading,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import PageHeader from 'components/page-header/PageHeader';
import PageTitleMobile from 'components/page-header/PageTitleMobile';
import StyleGuideItem from 'components/style-guides/StyleGuideItem';
import { IPaginationResponse } from 'dtos/pagination.dto';
import { IStyleGuide } from 'interfaces/style-guide.interface';
import { withIronSessionSsr } from 'iron-session/next';
import RootLayout from 'layouts/RootLayout';
import { sessionOptions } from 'libs/iron-session';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import useSWR from 'swr';
import { NextPageWithLayout } from '../_app';

const StyleGuidePage: NextPageWithLayout = () => {
  const { data } = useSWR<IPaginationResponse<IStyleGuide>>(
    `${process.env.NEXT_PUBLIC_API_URL}/v1/public/style-guides?limit=500`
  );

  return (
    <>
      <Head>
        <title>Style Guide | แลมป์ตั้น</title>
      </Head>
      <Box>
        <PageHeader title={`Style Guide`}></PageHeader>
        <PageTitleMobile>{`Style Guide`}</PageTitleMobile>
        <Container
          pt={{
            base: 8,
            md: 12,
          }}
          pb={{
            base: 8,
            md: 20,
          }}
        >
          <Box mb={8} pb={6} textAlign="center" position="relative">
            <Heading
              as="h1"
              fontSize="3xl"
              textTransform="uppercase"
              fontWeight={400}
            >
              Lamptan Style Guide
            </Heading>
            <Box
              height={1}
              width="100px"
              bg="primary.500"
              position="absolute"
              bottom={0}
              left={'50%'}
              transform="translateX(-50%)"
            ></Box>
          </Box>
          {data && data?.docs.length > 0 ? (
            <SimpleGrid columns={{ base: 2, md: 3, lg: 4 }} spacing={10}>
              {data?.docs.map((item) => {
                return (
                  <StyleGuideItem data={item} key={item.id}></StyleGuideItem>
                );
              })}
            </SimpleGrid>
          ) : (
            <Center>
              <Text>ไม่พบข้อมูล</Text>
            </Center>
          )}
        </Container>
      </Box>
    </>
  );
};

StyleGuidePage.getLayout = (page) => {
  return <RootLayout>{page}</RootLayout>;
};

export const getServerSideProps = withIronSessionSsr(async function ({
  locale,
}) {
  const _locale = locale || 'th';

  return {
    props: {
      ...(await serverSideTranslations(_locale, ['common'])),
    },
  };
},
sessionOptions);

export default StyleGuidePage;
